import { Chart } from '@frontend/chart/types';

export const SPOT_FILL_RATE_METRIC_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: 'Fill rate',
            data: [
                { label: '2026-06-01', value: 4 },
                { label: '2026-07-01', value: 4 },
                { label: '2026-08-01', value: 5 }
            ]
        }
    ]
};
